import { render } from "./ProposalVariableFields.vue?vue&type=template&id=79600ddf&scoped=true"
import script from "./ProposalVariableFields.vue?vue&type=script&lang=js"
export * from "./ProposalVariableFields.vue?vue&type=script&lang=js"

import "./ProposalVariableFields.vue?vue&type=style&index=0&id=79600ddf&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/spark_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79600ddf"]])

export default __exports__